import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledMultiProductsPricingComponent = styled.div`
  margin: auto;

  .product-switcher {
    margin-bottom: 390px;
  }

  .signup-form {
    .ladda-button-component {
      .signup-button,
      .cta-button {
        background-color: var(--primary-color);
        letter-spacing: 0.4px;
        max-width: none;
        width: 100%;
        border: none;
        padding: 16px 24px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .signup-form:hover {
    .signup-button:hover,
    .cta-button:hover {
      background-color: var(--secondary-color);
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .regular-signup-component {
      max-width: 320px;
      margin: 0 auto;
    }
  }
`;
